import { FlexComponent, ModuleDefinition } from "src/typings/flexFramework/FlexComponent";
import { Composition, Template } from "typings/flexFramework/FlexDefinitions";
import { BlossomRendererWithComposition } from "./BlossomRendererWithComposition";
import { BlossomRendererWithTemplate } from "components/flexFramework/renderer/BlossomRendererWithTemplate";
import { BlossomRenderer } from "components/flexFramework/renderer/BlossomRenderer";

export interface BlossomRendererFactoryProps {
  flexComponents?: FlexComponent[];
  template?: Template;
  moduleDefinitions?: ModuleDefinition[];
  composition?: Composition;
  isInsideTabGroup?: boolean;
}

/**
 * Factory that can helps decide what kind of renderer we want depending on the given props
 */
export class BlossomRendererFactory {
  public static get = (props: BlossomRendererFactoryProps): BlossomRenderer => {
    if (!props) {
      return new BlossomRendererWithComposition([]);
    }

    if (props.moduleDefinitions) {
      return new BlossomRendererWithTemplate(props.moduleDefinitions);
    }

    if (props.template) {
      return new BlossomRendererWithTemplate(props.template.regions);
    }

    if (props.flexComponents) {
      return new BlossomRendererWithComposition(props.flexComponents, props.isInsideTabGroup);
    }

    if (props.composition) {
      return new BlossomRendererWithComposition(
        props.composition.page.regionList,
        props.isInsideTabGroup
      );
    }

    return new BlossomRendererWithComposition([]);
  };
}
